import React, { useState } from 'react';
import styles from './SilentModeHint.module.css';
import { hasAudioSessionApi, isIOS } from '../../speech';

const DISMISSED_KEY = 'silentModeHintDismissed';

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * On iOS Safari before 16.4 there is no `navigator.audioSession`, so page audio
 * follows the ring/silent switch and lessons sound silent. Tell the learner how
 * to hear it. Everywhere else audio ignores the switch and nothing is shown.
 */
export const SilentModeHint: React.FC = () => {
  const [dismissed, setDismissed] = useState(wasDismissed);

  if (dismissed || !isIOS() || hasAudioSessionApi()) return null;

  const dismiss = (): void => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // storage blocked: the hint stays dismissed for this visit only
    }
  };

  return (
    <div className={styles.hint} role="note">
      <p>No sound? Turn off silent mode to hear the lesson audio.</p>
      <button
        type="button"
        className={styles.dismissButton}
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default SilentModeHint;
